import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogBase from "./_LogBase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = [
  { prop: "logindate", label: "Огноо" },
  { prop: "userid", label: "Хэрэглэгч" },
  { prop: "ipaddress", label: "IP" },
  { prop: "loginstatus", label: "Статус" },
  { prop: "orgcode", label: "Байгууллага" },
  { prop: "description", label: "Тайлбар" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LogBase, {
    title: "Нэвтэрсэн лог",
    endpoint: "/logs/login",
    columns: columns,
    show: { org: true, ip: true }
  }))
}
}

})